import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import useMoney from '../../../../../../../hooks/useMoney';
import LangEnum from '../../../../../../../lang/LangEnum';
import { BusinessPolicyValueInput } from '../../../../../../business-policies/domain/businessPolicyCapabilities.types';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { BusinessPolicyViolationGroupView } from '../businessPolicyViolation.types';
import { formatCriterionValue, getViolationItemLabel } from '../businessPolicyViolation.utils';

interface BusinessPolicyViolationGroupListProps {
  groups: BusinessPolicyViolationGroupView[];
  withinCriterionCount: number;
  valueInput: BusinessPolicyValueInput;
}

const BusinessPolicyViolationGroupList = ({
  groups,
  withinCriterionCount,
  valueInput,
}: BusinessPolicyViolationGroupListProps) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();

  return (
    <Stack
      sx={(theme) => ({
        gap: 0.5,
        marginLeft: 3,
        padding: 1,
        borderRadius: `${theme.shape.borderRadiusLg}px`,
        backgroundColor: theme.palette.action.hover,
      })}
    >
      {groups.map((group) => (
        <Stack
          key={group.itemKey ?? group.productColorId}
          direction="row"
          sx={{ gap: 1.5, justifyContent: 'space-between', alignItems: 'baseline' }}
        >
          <Typography variant="micro1" color="text.secondary" sx={{ minWidth: 0 }}>
            {getViolationItemLabel(group, translate)}
          </Typography>
          <Typography
            variant="micro1"
            color="text.primary"
            sx={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}
          >
            {formatCriterionValue(group.reached, valueInput, formatMoney)} /{' '}
            {formatCriterionValue(group.expected, valueInput, formatMoney)}
          </Typography>
        </Stack>
      ))}

      {withinCriterionCount > 0 && (
        <Typography variant="micro2" color="text.disabled">
          {translate(LangEnum.BUSINESS_POLICY_VIOLATION_ITEMS_WITHIN_CRITERION, {
            quantity: withinCriterionCount,
          })}
        </Typography>
      )}
    </Stack>
  );
};

export default BusinessPolicyViolationGroupList;
